import { useEffect } from 'react';
import { HOME_BASE_URL } from '../../../../src/helpers/connectionHelpers';

declare global {
  interface Window {
    homeEmbedConfig?: {
      attribution_code: string;
      lead_reference: string;
      first_name: string;
      postcode: string;
      tenancy_start: string;
      tenancy_status: string;
    };
  }
}

const HomeEmbed: React.FC = ({iFrameParams}) => {
  useEffect(() => {
    // Configure the global embed settings
    window.homeEmbedConfig = {
      attribution_code: iFrameParams?.attribution_code,
      lead_reference: iFrameParams?.lead_reference,
      first_name: iFrameParams?.first_name,
      postcode: iFrameParams?.postcode,
      tenancy_start: iFrameParams?.tenancy_start,
      tenancy_status: iFrameParams?.tenancy_status,
    };

    // Load the external script
    const script = document.createElement('script');
    script.src = `${HOME_BASE_URL}${HOME_BASE_URL.endsWith('/') ? '' : '/'}js/home`;
    script.defer = true;
    document.body.appendChild(script);

    // Cleanup on component unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div style={{width:'100%'}} id="home"></div>;
};

export default HomeEmbed;
